import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuctionsService {
  public LoadListNow = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiService) { }

  addAuction(model: any) {
    //model.date = this._DatePipe.transform(model.date, 'yyyy-MM-dd')

    return this.apiService
      .post(`${environment.apiUrl}auction/auctions`, model)
      .pipe(catchError(this.handleError));
  }

  delivered(model: any, id: string) {
    const formData = new FormData();
    formData.append('delivered_note', model.note);
    if (model.attached_file) {
      model.attached_file.forEach((element: any) => {
        formData.append('delivered_file', element, element.name);
      });
    }
    return this.apiService
      .post(`${environment.apiUrl}auction/delivered-and-collected/${id}`, formData)
      .pipe(catchError(this.handleError));
  }

  increasePrice(id: any) {
    return this.apiService.post(`${environment.apiUrl}auction/raise-my-bid/auctions/` + id).pipe(catchError(this.handleError));
  }

  UpdateAuction(model: any, auctionID: string) {
    //model.date = this._DatePipe.transform(model.date, 'yyyy-MM-dd')

    return this.apiService
      .update(`${environment.apiUrl}admin/auction/auctions/${auctionID}`, model)
      .pipe(catchError(this.handleError));
  }
  DeleteAuction(auctionID: string) {
    return this.apiService
      .remove(`${environment.apiUrl}auction/auctions/${auctionID}`)
      .pipe(catchError(this.handleError));
  }

  startAuction(auctionID: string) {
    //model.date = this._DatePipe.transform(model.date, 'yyyy-MM-dd')

    return this.apiService
      .update(`${environment.apiUrl}admin/auction/auctions/startAuctionNow/${auctionID}`, {})
      .pipe(catchError(this.handleError));
  }
  changeStatusAuction(url: any, auctionID: string) {

    return this.apiService
      .update(`${environment.apiUrl}${url}${auctionID}`, {})
      .pipe(catchError(this.handleError));
  }
  endAuctionWithoutWinner(auctionID: string) {
    //model.date = this._DatePipe.transform(model.date, 'yyyy-MM-dd')

    return this.apiService
      .update(`${environment.apiUrl}admin/auction/auctions/endAuctionWithoutWinner/${auctionID}`, {})
      .pipe(catchError(this.handleError));
  }


  endAuctionWithWinner(auctionID: string) {
    return this.apiService
      .update(`${environment.apiUrl}admin/auction/auctions/endAuctionWithWinner/${auctionID}`, {})
      .pipe(catchError(this.handleError));
  }


  auctionDetailes(model: any) {
    return this.apiService
      .get(`${environment.apiUrl}auction/auctions/${model.id}`)
      .pipe(catchError(this.handleError));
  }




  allAuctions(modal: any) {
    return this.apiService
      .get(`${environment.apiUrl}auction/auctions`, modal)
      .pipe(catchError(this.handleError));
  }


  GetUserAuctions(modal: any) {
    modal.start_date = modal.start_date ? moment(modal.start_date).format('YYYY-MM-DD') : modal.start_date;
    modal.end_date = modal.end_date ? moment(modal.end_date).format('YYYY-MM-DD') : modal.end_date;
    return this.apiService
      .get(`${environment.apiUrl}userManagement/users/${modal.user_id}/auctions`, modal)
      .pipe(catchError(this.handleError));
  }

  GetUserJoinedAuctions(modal: any) {

    return this.apiService
      .get(`${environment.apiUrl}userManagement/users/${modal.user_id}/rooms`, modal)
      .pipe(catchError(this.handleError));
  }


  getCategories() {
    return this.apiService
      .get(`${environment.apiUrl}auction/categories?perPage=20&sort=ASC`)
      .pipe(catchError(this.handleError));
  }


  setLoadListValue(value: boolean) {
    this.LoadListNow.next(value)
  }

  getLoadListValue() {
    return this.LoadListNow.asObservable();
  }

  getCategorytemplate(category_id: string) {
    return this.apiService
      .get(`${environment.apiUrl}auction/templates/${category_id}`)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }

}
